import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { oidcActions } from './redux';
import { useBasketAdmin, useKeroOnly } from './useAuthenticated';

export function AuthedReduxConnector() {
	const dispatch = useDispatch();
	const isBasketAdmin = useBasketAdmin();
	const isKeroOnly = useKeroOnly();

	// Emulate old oidc actions
	useEffect(() => {
		dispatch({
			type: oidcActions.USER_FOUND,
			isBasketAdmin,
			isKeroOnly,
		});
	}, [dispatch, isBasketAdmin, isKeroOnly]);

	return null;
}

export default AuthedReduxConnector;
